import { setItem } from 'storage';
import { SET_COLUMN } from 'store/key';
import { produce } from 'utility/general';

export const defaultPostApprovalColumn = [
    {
        key: 'pending',
    },
    {
        key: 'subNo',
    },
    {
        key: 'p1scientificTitle',
    },
    {
        key: 'uploadDate',
    },
    {
        key: 'documentType',
    },
    {
        key: 'statusId',
    },
    {
        key: 'expiryDate',
    },
    {
        key: 'action',
    },
];

export const defaultApplicationColumn = [
    {
        key: 'subTable',
    },
    {
        key: 'recRef',
    },
    {
        key: 'pending',
    },
    {
        key: 'id',
    },
    {
        key: 'submitId',
    },
    {
        key: 'date',
    },
    {
        key: 'title',
    },
    {
        key: 'pi',
    },
    {
        key: 'sites',
    },
    {
        key: 'status',
    },
    {
        key: 'action',
    },
    {
        key: 'return',
    },
    {
        key: 'expired',
    },
];

const initialState = { application: defaultApplicationColumn, postApproval: defaultPostApprovalColumn };
export const APPLICATION_COLUMN = 'application_column';
export const POST_APPROVAL_COLUMN = 'post_approval_column';

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_COLUMN:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export const updateApplicationColumn = (data) => {
    setItem(APPLICATION_COLUMN, data);
    return {
        type: SET_COLUMN,
        payload: { postApproval: data },
    };
};

export const updatePostApprovalColumn = (data) => {
    setItem(POST_APPROVAL_COLUMN, data);
    return {
        type: SET_COLUMN,
        payload: { postApproval: data },
    };
};

// function* updateApplicationColumnWidth(action) {
//     const data = action.payload;
//     const { column: currentState } = yield select();
//     const { width, field } = data;
//     const newState = produce(currentState, (draft) => {
//         const index = draft.application.findIndex((item) => item.key === field);

//         if (index !== -1) {
//             draft.application[index].width = width;
//         }
//     });

//     console.log('150020 columnReducer.js newState', newState)

//     yield put({ type: SET_COLUMN, payload: newState });
// }

// function* updatePostApprovalColumnWidth(action) {
//     const { width, field } = action.payload;
//     const { column: currentState } = yield select();
//     const newState = produce(currentState, (draft) => {
//         const index = draft.postApproval.findIndex((item) => item.key === field);

//         if (index !== -1) {
//             draft.postApproval[index].width = width;
//         }
//     });

//     yield put({
//         type: SET_COLUMN,
//         payload: newState,
//     });
// }

export default reducer;
